import React, { useEffect } from 'react';





import Icon1 from '../assets/img/about/icon1.png';
import Icon2 from '../assets/img/about/icon2.png';
import Icon3 from '../assets/img/about/icon3.png';
import Icon4 from '../assets/img/about/icon4.png';
import Icon11 from '../assets/img/about/icon11.png';
import Icon21 from '../assets/img/about/icon21.png';
import Icon31 from '../assets/img/about/icon31.png';
import Icon41 from '../assets/img/about/icon41.png';

import Start from '../assets/img/about/Star.png';

import Img1 from '../assets/img/cancellation/privacy1.png';
import Img2 from '../assets/img/cancellation/privacy2.png';
import Img3 from '../assets/img/cancellation/privacy3.png';
import Img4 from '../assets/img/cancellation/privacy4.png';
import Img5 from '../assets/img/cancellation/privacy5.png';
import Img6 from '../assets/img/cancellation/privacy6.png';
import Img7 from '../assets/img/cancellation/privacy7.png';
import Img8 from '../assets/img/cancellation/privacy8.png';
import Img9 from '../assets/img/cancellation/privacy9.png';
import Img10 from '../assets/img/cancellation/privacy10.png';
import Img11 from '../assets/img/cancellation/privacy11.png';
import Img12 from '../assets/img/cancellation/privacy12.png';


import SeoHelmet from "../components/SeoHelmet";

const PrivacyPolicy = () => {

     useEffect(() => {
    document.body.classList.add('about-page');

    return () => {
      document.body.classList.remove('about-page');
    };
  }, []);

  return (
    <>
     <SeoHelmet />


        <section class="about cancellation">
            <div className='container'>
                <div className='mbrweb_row'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img1} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>Privacy Policy</h2> 
                           <p>This Privacy Policy explains how thebhavanasingh.com ("Website") collects, uses, shares, and protects your personal data when you use our Website or Services.</p>
                           <p>We aim to comply with applicable Indian data protection laws, including the Digital Personal Data Protection Act, 2023 and relevant IT law provisions/rules.</p>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img2} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>1. What We Collect</h2> 
                           <p>Depending on how you interact with us, we may collect:</p> 
                            <div className='mbr_inner'>
                                {/* <div className='mbr-col-sm-6'>
                                    <img src={Img11} />
                                </div> */}
                                <div className='mbr-col-sm-6'>
                                    <h2>A) Information you provide</h2> 
                                    <p><span>Name, email, phone number, city</span></p> 
                                    <p>Billing details (your payment is typically processed by payment gateways; we may not store full card details)</p>
                                    <p>Information you share during onboarding: goals, preferences, style concerns</p>
                                    <p>Messages sent to us (email, WhatsApp, contact forms)</p>
                                    <p>Photos/videos you voluntarily share for review/feedback (if applicable)</p> 
                                </div>   
                            </div> 

                            <div className='mbr_inner'>
                                {/* <div className='mbr-col-sm-6'>
                                    <img src={Img11} />
                                </div> */}
                                <div className='mbr-col-sm-6'>
                                    <h2>B) Automatic data</h2> 
                                    <p>Device data (browser type), IP address, approximate location</p>
                                    <p>Website usage data (pages visited, time spent)</p> 
                                     <p>Cookies and analytics data</p> 
                                </div>   
                            </div> 

                           
                                                
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img3} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>2. How We Use Your Data</h2> 
                           <p>We use data to:</p> 
                           <ul>
                            <li>deliver Services and manage bookings</li>
                            <li>communicate schedules, updates, links, and support</li>
                            <li>personalize your experience (where relevant)</li>
                            <li>improve Website performance and program quality</li>
                            <li>send marketing/updates (you can opt out anytime)</li>
                            <li>prevent fraud, misuse, and policy violations</li>
                            <li>comply with legal obligations</li>
                            </ul>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img4} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>3. Legal Basis / Grounds (Plain-English)</h2> 
                           <p>We process your data primarily for:</p> 
                           <ul>
                            <li><span>performance of a service/contract </span>deliver Services and manage bookings</li>
                            <li><span>consent </span>(especially for marketing or optional info),</li>
                            <li><span>legal compliance </span>(tax, payments, lawful requests).</li>
                        
                            </ul>                          
                        </div>
                    </div>
                </div>
                
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img5} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>4. Sharing of Data</h2> 
                           <p>We may share limited data with:</p> 
                           <ul>
                            <li><span className='privacy_b'>service providers: </span>website hosting, email, WhatsApp/CRM tools, analytics</li>
                             <li><span className='privacy_b'>payment gateways: </span>to process payments</li>
                              <li><span className='privacy_b'>session platforms: </span>to host online sessions</li>
                               <li><span className='privacy_b'>legal/regulatory authorities: </span>if required by law</li>
                        
                            </ul>                          
                        </div>
                        <div className='warning'>
                                 <div className='mbr-col-sm-6'>
                                    <img src={Img6} />
                                </div>
                                <div className='mbr-col-sm-6'>
                                     <p><span className='warn_bold'>We do not sell your personal data.</span></p>
                                  
                                </div>
                            </div>  
                    </div>
                   
                </div>
                
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img6} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>5. Cookies</h2> 
                           <p>We use cookies for basic site functionality and analytics. You can manage cookies via browser settings, but some features may not work correctly.</p>                          
                        </div>
                    </div>
                </div>

                  <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img7} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>6. Data Retention</h2> 
                           <p>We retain data only as long as needed for:</p> 
                           <ul>
                            <li>delivering Services,</li>
                            <li>legitimate business purposes,</li>
                            <li>legal/tax requirements.</li>
                            </ul>                          
                        </div>
                    </div>
                </div>

                <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img8} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>7. Security</h2> 
                           <p>We use reasonable security practices to protect your data. However,<span>no online system is 100% secure</span></p>                          
                        </div>
                    </div>
                </div>

                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img9} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>8. Your Rights (India)</h2> 
                           <p>Subject to applicable law, you may request:</p> 
                           <ul>
                            <li><span>access </span>to information about your personal data,</li>
                            <li><span>correction </span>of inaccurate data,</li>
                            <li><span>withdrawal of consent </span>(where processing is consent-based),</li>
                            <li><span>grievance redressal </span></li>
                            </ul>                          
                        </div>
                    </div>
                </div>

                 
                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img10} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>9. Grievance Redressal</h2> 
                           <p>If you have a complaint or request:</p> 
                           <ul>
                            <li><span className='privacy_b'>Email: </span><span>[Insert grievance/support email]</span></li>
                             <li><span className='privacy_b'>Subject line: </span>"Privacy Request – thebhavanasingh.com"</li>
                            </ul>  
                            <p>Where applicable, we aim to respond within reasonable timelines (traditional IT rules referenced grievance handling within about a month in certain contexts).</p>                        
                        </div>
                    </div>
                   
                </div>

                 <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img11} />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>10. Children's Privacy</h2> 
                           <p>Our Services are intended for adults. If you believe a minor has shared personal data with us without appropriate consent, <span>contact us to remove it</span></p>                           
                        </div>
                    </div>
                </div>

                  <div className='mbrweb_row mbrweb_row_1'>
                    <div className='mbr-col-sm-6'>
                        <img src={Img12 } />
                    </div>
                    <div className='mbr-col-sm-6'>
                        <div className='about_content'>                            
                           <h2>11. Policy Updates</h2> 
                           <p>We may update this Privacy Policy periodically. The <span>"Last Updated"</span>date will reflect changes.</p>                           
                        </div>
                    </div>
                </div>

                <div className='mbr_bottom'>
                    <p>
                       Last Updated: January 5, 2026
                       <br></br>
                        For questions about this policy, please contact our support team.
                    </p>
                  
                </div>
            </div>
        </section>
       
    </>
  );
}; 

export default PrivacyPolicy;
